export default __webpack_public_path__ + "static/media/dashboard.fec0be75.png";